import { makeAuthorizedRequest } from './requests';

export function checkEligibility(patientId, data) {
  return makeAuthorizedRequest('POST', `/patients/${patientId}/eligibility-check`, data);
}

export function getCheckEligibilityRequests(patientId, requestIds) {
  const requestIdsParam = requestIds && requestIds.length > 0 ?
    `?requestIds=${encodeURIComponent(requestIds.join(','))}` : '';
  return makeAuthorizedRequest('GET', `/patients/${patientId}/eligibility-check${requestIdsParam}`);
}

export function getMostRecentEligibilityChecks(patientId) {
  return makeAuthorizedRequest('GET', `/patients/${patientId}/eligibility-check-recent`);
}

export function getPayerInfo(patientId, payerId) {
  return makeAuthorizedRequest('GET', `/patients/${patientId}/eligibility-payers/${payerId}`);
}
